var map = {
	"./Web": 243,
	"./Web.jsx": 243,
	"./WebPageComponent": 237,
	"./WebPageComponent.js": 237,
	"./angularjs": 549,
	"./angularjs.js": 549,
	"./dotnet": 550,
	"./dotnet.js": 550,
	"./e-commerce-cms": 551,
	"./e-commerce-cms.js": 551,
	"./java": 552,
	"./java.js": 552,
	"./magento": 553,
	"./magento.js": 553,
	"./nodejs": 554,
	"./nodejs.js": 554,
	"./php": 555,
	"./php.js": 555,
	"./reactjs": 556,
	"./reactjs.js": 556,
	"./web-development": 557,
	"./web-development.js": 557,
	"./wordpress": 558,
	"./wordpress.js": 558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;